import * as React from 'react';
import { Navigate } from 'react-router-dom';
import AuthService from '../services/auth.js';

import Box from '@mui/material/Box';

import { IconButton } from "@mui/material";
import Typography from '@mui/material/Typography';

import FlipCameraIosIcon from '@mui/icons-material/FlipCameraIos';
import CloseIcon from '@mui/icons-material/Close';
import CropFreeIcon from '@mui/icons-material/CropFree';
import AppConfig from '../services/app-config';



export default function Camera(props) {
  const [redirect, setRedirect] = React.useState({ trigger: false, route: '/' });
  const [imageDataURL, setImageDataURL] = React.useState(null);
//   const [cameraNumber, setCameraNumber] = React.useState(0);
  
  React.useEffect(() => {
    initializeMedia(true);

  }, []);

  let player = null;
  let cameraNumber = 0

  const initializeMedia = async (initial=false) => {
    setImageDataURL(null);
    if (!("mediaDevices" in navigator)) {
      navigator.mediaDevices = {};
    }

    if (!("getUserMedia" in navigator.mediaDevices)) {
      navigator.mediaDevices.getUserMedia = function (constraints) {
        var getUserMedia =
          navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

        if (!getUserMedia) {
            return Promise.reject(new Error("getUserMedia Not Implemented"));
        }

        return new Promise((resolve, reject) => {
            getUserMedia.call(navigator, constraints, resolve, reject);
        });
      };
    }

    //Get the details of video inputs of the device
    const videoInputs = await getListOfVideoInputs();
    //The device has a camera
    if (videoInputs.length) {
        if (videoInputs.length > 1 && initial) {
            cameraNumber = 1;
        }
        navigator.mediaDevices
            .getUserMedia({
                video: {
                    deviceId: {
                        exact: videoInputs[cameraNumber].deviceId,
                    },
                },
            })
            .then((stream) => {
                player.srcObject = stream;
            })
            .catch((error) => {
                if (error.name === "OverconstrainedError") {
                    console.log("Video constraints cannot be met by the device");
                } else {
                    console.error(error);
                }
            });
    } else {
        alert("The device does not have a camera");
    }
  };

  const capturePicture = () => {
    var canvas = document.createElement("canvas");
    canvas.width = player.videoWidth;
    canvas.height = player.videoHeight;
    var contex = canvas.getContext("2d");
    contex.drawImage(player, 0, 0, canvas.width, canvas.height);
    player.srcObject.getVideoTracks().forEach((track) => {
      track.stop();
    });

    console.log(canvas.toDataURL());
    setImageDataURL(canvas.toDataURL());
  };

  const switchCamera = async () => {
    const listOfVideoInputs = await getListOfVideoInputs();

    // The device has more than one camera
    if (listOfVideoInputs.length > 1) {
      if (player.srcObject) {
        player.srcObject.getVideoTracks().forEach((track) => {
          track.stop();
        });
      }

      // switch to second camera
      if (cameraNumber === 0) {
        cameraNumber = 1;
      }
      // switch to first camera
      else if (cameraNumber === 1) {
        cameraNumber = 0;
      }

      // Restart based on camera input
      initializeMedia();
    } else if (listOfVideoInputs.length === 1) {
      alert("The device has only one camera");
    } else {
      alert("The device does not have a camera");
    }
  };

  const getListOfVideoInputs = async () => {
    // Get the details of audio and video output of the device
    await navigator.mediaDevices.getUserMedia({audio: true, video: true});
    const enumerateDevices = await navigator.mediaDevices.enumerateDevices();

    //Filter video outputs (for devices with multiple cameras)
    return enumerateDevices.filter((device) => device.kind === "videoinput");
  };

    return (
        <Box sx={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: '#000', display: 'flex', flexDirection: 'column',
          zIndex: 1300
        }}>
        {redirect.trigger && (
            <Navigate to={redirect.route} replace={true} />
        )}

        {/* Top bar */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1.5, position: 'absolute', top: 0, left: 0, right: 0, zIndex: 2 }}>
          <IconButton onClick={() => setRedirect({ trigger: true, route: '/' })} sx={{ color: '#fff' }}>
            <CloseIcon />
          </IconButton>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <IconButton sx={{ color: '#fff' }}>
              <CropFreeIcon />
            </IconButton>
          </Box>
        </Box>

        {/* Camera viewfinder */}
        <Box sx={{
          flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
          overflow: 'hidden', mx: 1, my: 1, borderRadius: 4
        }}>
          {imageDataURL ? (
            <img src={imageDataURL} alt="cameraPic" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '24px' }} />
          ) : (
            <video
              ref={(refrence) => { player = refrence; }}
              autoPlay
              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '24px' }}
            ></video>
          )}
        </Box>

        {/* Bottom controls */}
        <Box sx={{ pb: 4, pt: 1, px: 3 }}>
          <Typography variant="body2" align="center" sx={{ color: 'rgba(255,255,255,0.7)', mb: 2, fontSize: '0.8rem' }}>
            Tomar foto del reporte
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 4 }}>
            {/* Thumbnail placeholder */}
            <Box sx={{
              width: 44, height: 44, borderRadius: 2, border: '2px solid rgba(255,255,255,0.3)',
              backgroundColor: 'rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              {imageDataURL && (
                <img src={imageDataURL} alt="thumb" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '6px' }} />
              )}
            </Box>

            {/* Capture button */}
            <IconButton
              aria-label="capture photo"
              onClick={capturePicture}
              sx={{
                width: 68, height: 68, backgroundColor: '#fff',
                border: '4px solid rgba(255,255,255,0.3)',
                '&:hover': { backgroundColor: '#e0e0e0' }
              }}
            >
              <Box sx={{ width: 52, height: 52, borderRadius: '50%', backgroundColor: '#fff' }} />
            </IconButton>

            {/* Flip camera */}
            <IconButton
              aria-label="switch camera"
              onClick={switchCamera}
              sx={{
                width: 44, height: 44, backgroundColor: 'rgba(255,255,255,0.15)',
                color: '#fff', '&:hover': { backgroundColor: 'rgba(255,255,255,0.25)' }
              }}
            >
              <FlipCameraIosIcon />
            </IconButton>
          </Box>
        </Box>
        </Box>
    );
}